/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const DragIcon = ({
  className,
  style,
  color = '#938bb7',
  onClick,
  ...rest
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 7 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...rest}
    >
      <path
        d="M6.04715 12.4987C5.89095 12.3523 5.63768 12.3523 5.48145 12.4987L3.76665 14.1214V1.87851L5.48145 3.50126C5.63765 3.6477 5.89092 3.6477 6.04715 3.50126L6.28282 3.2803C6.43902 3.13386 6.43902 2.89642 6.28282 2.74998L3.48282 0.109828C3.32662 -0.0366094 3.07335 -0.0366094 2.91712 0.109828L0.11715 2.74998C-0.03905 2.89642 -0.03905 3.13386 0.11715 3.2803L0.352817 3.50126C0.509017 3.6477 0.762283 3.6477 0.918517 3.50126L2.63332 1.87851V14.1214L0.918517 12.4987C0.762317 12.3522 0.50905 12.3522 0.352817 12.4987L0.11715 12.7196C-0.03905 12.8661 -0.03905 13.1035 0.11715 13.2499L2.91715 15.8901C3.07335 16.0366 3.32662 16.0366 3.48285 15.8901L6.28285 13.2499C6.43905 13.1035 6.43905 12.8661 6.28285 12.7196L6.04715 12.4987Z"
        fill={color}
      />
    </svg>
  );
};
